/* BrComfy cart helper (ES module).
   window.BRC.add(variantId, qty) adds a line through the same standard
   cart event Fabric's product form uses, so the cart drawer re-renders
   and auto-opens exactly like a normal add to cart. */
import { CartLinesUpdateEvent } from '@shopify/events';

const BRC = (window.BRC = window.BRC || {});
const routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
const ADD_URL = routes.cart_add_url || '/cart/add.js';
const CART_URL = (routes.cart_url || '/cart') + '.js';

BRC.add = async function add(variantId, quantity = 1) {
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }], sections: sectionIds.join(',') }),
    }).then((r) => r.json());

    const ajaxCart = await fetch(CART_URL, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const toCart = CartLinesUpdateEvent.createCartFromAjaxResponse || ((c) => c);
    deferred.resolve({
      cart: toCart(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'brc-quick-add',
        sections: res.sections,
        didError: Boolean(res.status),
        itemCount: quantity,
      },
    });
    if (res.status) throw new Error(res.description || res.message || 'Could not add to bag');
    return res;
  } catch (err) {
    try { deferred.reject(err); } catch (e) {}
    throw err;
  }
};

document.dispatchEvent(new CustomEvent('brc:cart-ready'));
